<!--
 * @Author: Merlin
 * @Date: 2024-05-29 16:47:38
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-22 16:29:27
 * @Description: 
-->

<template>
    <div
        class="grid relative grid-cols-3 rounded-xl bg-background-80 py-2 px-1 content-center"
    >
        <div class="flex flex-col m-auto">
            <span class="text-grey-40 font-medium text-center text-xs">
                {{ t.Multiplier }}
            </span>
            <span class="text-[20px] font-bold text-center">
                {{ getFixed(Number(mutipler)) }}
            </span>
        </div>
        <div class="flex flex-col m-auto">
            <span class="text-grey-40 font-medium text-center text-xs">
                {{ t.Chancetowin }}
            </span>
            <span class="text-[20px] font-bold text-center">
                {{ percentage }}%
            </span>
        </div>
        <!-- ↓追加项（获胜的金额） -->
        <div class="flex flex-col m-auto">
            <span class="text-grey-40 font-medium text-center text-xs">
                {{ t.ProfitOnWin }}
            </span>
            <span class="text-[20px] font-bold text-center">
                {{ 
                    expectedReward
                    ? getFixed(Number(expectedReward))
                    : getFixed(Number(amount) * Number(mutipler))
                }}
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();
const props = defineProps({
    percentage: {
        type: [Number, String],
        required: true,
        default: 0,
    },
    mutipler: {
        type: [Number, String],
        required: true,
        default: 0,
    },
    amount: {
        type: [Number, String],
        default: 0,
    },
    expectedReward: {
        type: [Number, String],
        default: 0,
    },
});


</script>

